import { error, success } from "App/popupMessage";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getSummaryReportDetails: (summaryReportId) => ({
        type: actionTypes.GET_SUMMARY_REPORT_DETAILS,
        payload: {
            promise: () => api.getSummaryReportDetails(summaryReportId)
        },
        scope: `${actionTypes.GET_SUMMARY_REPORT_DETAILS}_${summaryReportId}`
    }),
    saveSummaryReportDetails: (data) => ({
        type: actionTypes.SAVE_SUMMARY_REPORT_DETAILS,
        payload: {
            promise: () => api.saveSummaryReportDetails(data)
        },
        meta: { data },
        scope: `${actionTypes.SAVE_SUMMARY_REPORT_DETAILS}_${data.Id}`,
        completed: (disp) => {
            disp(success(locale.buildSummaryReportSavedSuccessfully(data.Name)));
        },
        rejected: (disp) => {
            disp(error(locale.buildSummaryReportSavingFailed(data.Name)));
        }
    }),
    clearData: (exceptSummaryReportId) => ({
        type: actionTypes.CLEAR_DATA,
        exceptSummaryReportId
    })
};
